import { Component, Input } from '@angular/core';

@Component({
  selector: 'create-svg',
  templateUrl: './create.component.html',
  styleUrls: ['./../../../svg.scss']
})
export class CreateSvgComponent {
  @Input() active:boolean=false;
  @Input() direction:string='';
  @Input() color: string='';
  constructor() { }

}
